import styles from './table.module.scss';
import { TableProps } from './types';

export function table({ children, source }: TableProps) {
  return (
    <div
      className={styles.wrapper}
      {...(source
        ? {
            'data-strapi-source': source,
            'data-strapi-markdown': '',
          }
        : {})}
    >
      <table className={styles.table}>{children}</table>
    </div>
  );
}
